import { ICustomerAttachment } from 'pages/Customers/Customers.models';
import {
  CREATE_CUSTOMERS_ATTACHMENT_FAILURE,
  CREATE_CUSTOMERS_ATTACHMENT_REQUEST,
  CREATE_CUSTOMERS_ATTACHMENT_SUCCESS,
} from 'pages/Customers/CustomersAttachments/CreateCustomersAttachment/actionTypes';
import {
  EDIT_CUSTOMERS_ATTACHMENT_NAME_REQUEST,
  EDIT_CUSTOMERS_ATTACHMENT_NAME_SUCCESS,
  EDIT_CUSTOMERS_ATTACHMENT_NAME_FAILURE,
} from 'pages/Customers/CustomersAttachments/EditCustomersAttachmentName/actionTypes';

import {
  GET_CUSTOMERS_ATTACHMENTS_REQUEST,
  GET_CUSTOMERS_ATTACHMENTS_SUCCESS,
  GET_CUSTOMERS_ATTACHMENTS_FAILURE,
} from 'pages/Customers/CustomersAttachments/GetCustomersAttachments/actionTypes';

import {
  REMOVE_CUSTOMERS_ATTACHMENT_FAILURE,
  REMOVE_CUSTOMERS_ATTACHMENT_REQUEST,
  REMOVE_CUSTOMERS_ATTACHMENT_SUCCESS,
} from 'pages/Customers/CustomersAttachments/RemoveCustomersAttachment/actionTypes';
import {
  CLEAR_ERRORS_CUSTOMERS_ATTACHMENTS,
} from 'pages/Customers/CustomersAttachments/ClearErrorsAttachments/actionTypes';

interface IAttachmentsState {
  error: string
  isLoading: boolean
  data: {
    results: ICustomerAttachment[]
  }
}

const initialState: IAttachmentsState = {
  error: '',
  isLoading: false,
  data: {
    results: [],
  },
};

const attachmentsReducer = (state = initialState, {
  type,
  attachments,
  newAttachment,
  attachmentId,
  editedAttachmentName,
  error,
}) => {
  switch (type) {
    case GET_CUSTOMERS_ATTACHMENTS_REQUEST:
    case CREATE_CUSTOMERS_ATTACHMENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case GET_CUSTOMERS_ATTACHMENTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          results: attachments,
        },
        error: '',
      };
    case CREATE_CUSTOMERS_ATTACHMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          results: [...state.data.results, newAttachment],
        },
        error: '',
      };
    case GET_CUSTOMERS_ATTACHMENTS_FAILURE:
    case CREATE_CUSTOMERS_ATTACHMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error,
      };
    case EDIT_CUSTOMERS_ATTACHMENT_NAME_REQUEST:
    case REMOVE_CUSTOMERS_ATTACHMENT_REQUEST:
      return {
        ...state,
        data: {
          ...state.data,
          results: state.data.results.map((attachment) => ((attachment.id === attachmentId) ? {
            ...attachment,
            isLoading: true,
          } : attachment)),
        },
      };
    case EDIT_CUSTOMERS_ATTACHMENT_NAME_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          results: state.data.results.map((attachment) => (
            (attachment.id === editedAttachmentName.id) ? {
              ...attachment,
              ...editedAttachmentName,
              isLoading: false,
              error: '',
            } : attachment)),
        },
      };
    case REMOVE_CUSTOMERS_ATTACHMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: {
          ...state.data,
          results: state.data.results.filter(
            (attachment) => attachment.id !== attachmentId,
          ),
        },
      };
    case EDIT_CUSTOMERS_ATTACHMENT_NAME_FAILURE:
      return {
        ...state,
        data: {
          ...state.data,
          results: state.data.results.map((attachment) => ((attachment.id === attachmentId) ? {
            ...attachment,
            isLoading: false,
            error,
          } : attachment)),
        },
      };
    case REMOVE_CUSTOMERS_ATTACHMENT_FAILURE:
      return {
        ...state,
        data: {
          ...state.data,
          results: state.data.results.map((attachment) => ((attachment.id === attachmentId) ? {
            ...attachment,
            isLoading: false,
            error,
          } : attachment)),
        },
      };
    case CLEAR_ERRORS_CUSTOMERS_ATTACHMENTS:
      return {
        ...state,
        data: {
          ...state.data,
          results: state.data.results.map((attachment) => ({
            ...attachment,
            error: '',
          })),
        },
        error: '',
      };
    default:
      return state;
  }
};

export default attachmentsReducer;
